import React from 'react';
import ReactDOM from 'react-dom';
// import { CountingProvider } from './providers/CountingProvider';
import App from './App';
// import DebugObserver from './debug/DebugObserver';
import { RecoilRoot } from 'recoil';


ReactDOM.render(
	<React.StrictMode>
    {/* <CountingProvider> */}
    <RecoilRoot>
      {/* <DebugObserver /> */}
      <React.Suspense fallback={<div>Loading...</div>}>
      <App />
      </React.Suspense>
    </RecoilRoot>
		{/* </CountingProvider> */}
	</React.StrictMode>,
  document.getElementById('root')
);

